import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const PAYMENT_DASHBOARD_ANALYTICS_ACTIONS = {
  trackPageLoad: createAction(
    '[NgRxClient Analytics] - Track Payment Dashboard Page Load',
    props<{
      tracking: Tracking;
    }>(),
  ),

  trackTileClick: createAction(
    '[NgRxClient Analytics] - Track Payment Dashboard Click Tile',
    props<{
      tracking: Tracking;
    }>(),
  ),

  trackOutboundLink: createAction(
    '[NgRxClient Analytics] - Track Payment Dashboard Outbound Link',
    props<{
      tracking: Tracking;
    }>(),
  ),

  trackSearch: createAction(
    '[NgRxClient Analytics] - Track Payment Dashboard Search',
    props<{
      tracking: Tracking;
    }>(),
  ),

  trackModalOpen: createAction(
    '[NgRxClient Analytics] - Track Payment Dashboard Modal Open',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
